import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";
import { formatDate } from "@/lib/media";

interface NewsHighlightProps {
  items: NewsItem[];
}

export default function NewsHighlight({ items }: NewsHighlightProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
      {items.map((item) => (
        <Link
          key={item.id}
          to={`/news/detail/${item.id}`}
          className="group rounded-lg overflow-hidden bg-background-900 border border-background-800 hover:border-primary-500/60 transition-colors flex flex-col"
        >
          <div className="relative w-full aspect-[16/9] bg-background-800 overflow-hidden">
            <img
              src={item.cover}
              alt={item.title}
              title={`${item.title} - 影视资讯`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
              {item.category}
            </span>
          </div>
          <div className="p-4 md:p-5 flex flex-col flex-1">
            <h3 className="text-base font-medium text-foreground-100 leading-snug line-clamp-2 group-hover:text-primary-400 transition-colors">
              {item.title}
            </h3>
            <p className="text-sm text-foreground-400 mt-2.5 line-clamp-2 flex-1">{item.summary}</p>
            <div className="flex items-center gap-3 mt-4 text-xs text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-user-line"></i>
                {item.author}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                {formatDate(item.date)}
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}